import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import staffApi from "api/staffApi";

export const getStaffs = createAsyncThunk("Staff" , async (params: any = {}) => {
  try{
    const response = await staffApi.staffs(formatQueryParams(params))
    return response;
  }catch (error) {
    return error;
  }
});

export const getListStaff =  async(params: any = {}) => {
  try{
    const response = await staffApi.staffs(params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postStaff = async (data: any = {}) => {
  try{
    const response = await staffApi.postStaff(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putStaff = async (id: string | number , data: any = {}) => {
  try{
    const response = await staffApi.putStaff(id, data);
    return response;
  }catch (error) {
    return error;
  }
};


